export enum STUDENT_PANEL_VIEW {
  MENU = 'menu',
  APPOINTMENTS = 'appointments',
  MY_TUTOR = 'myTutor',
  CALENDAR = 'calendar',
  RECEIPTS = 'receipts',
  SETTINGS = 'settings',
  OBSERVER = 'observer',
}

export enum STUDENT_OBSERVER_PANEL_VIEW {
  MENU = 'menu',
  APPOINTMENTS = 'appointments',
  TUTORS = 'tutors',
}
